export default "__VITE_ASSET__D6M$gxBI__"